import { Component, ElementRef, EventEmitter, Input, AfterViewInit, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ListColumn } from './list-column.model';

@Component({
  selector: 'vr-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListComponent implements OnInit, AfterViewInit {

  @Input() name: string;
  @Input() columns: ListColumn[];
  @Input() initialFilter: string = '';
  @Input() filterLocked: boolean = false;

  @ViewChild('filter') filter: ElementRef;
  @Output() filterChange = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
    Observable.fromEvent(this.filter.nativeElement, 'keyup').distinctUntilChanged().debounceTime(750).subscribe(() => {
      this.filterChange.emit(this.filter.nativeElement.value);
    });
  }

  ngAfterViewInit() {
    if (this.initialFilter) {
      this.filter.nativeElement.value = this.initialFilter;
      this.filterChange.emit(this.initialFilter);
    }
  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/list/list.component.ts